export default "__VITE_ASSET__84c43f55__"